import apiClient from "../apiClient";
export const loginSP = async (userData) => {
  try {
    const response = await apiClient.post(
      "login/login-service-providers",
      userData
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const getProviderById = async (providerId) => {
  try {
    const response = await apiClient.get(`proffessionals/getOne/${providerId}`);
    return response?.data?.data?.provider;
  } catch (error) {
    throw error;
  }
};

export const gettAllSpecialist = async () => {
  try {
    const response = await apiClient.get("proffessionals/getAll-sp");
    return response?.data?.data?.providers ?? [];
  } catch (error) {
    throw error;
  }
};
